<template>
    <button type="button" :class="buttonClass" :title="label" :aria-label="label" :disabled="disabled || loading">
        <span v-if="loading" class="spinner-border spinner-border-sm"></span>
        <i v-else :class="['bi', icon]"></i>
    </button>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
    name: "IconButton",
    props: {
        icon: { type: String, required: true },
        label: { type: String, required: true },
        tone: {
            type: String,
            default: "",
            validator: (value: string) => ["", "emerald", "indigo", "amber", "danger"].includes(value)
        },
        disabled: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
    },
    setup(props) {
        const buttonClass = computed(() => ["au-icon-btn", props.tone ? `is-${props.tone}` : ""]);
        return { buttonClass };
    },
});
</script>
